import "core-js/modules/es.object.assign.js";
import { defineComponent as _defineComponent } from 'vue';
import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-fdc11812"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = ["data-cy"];
import { computed } from "vue";
export default /*#__PURE__*/_defineComponent(Object.assign({
  inheritAttrs: false
}, {
  __name: 'BaseCard',
  props: {
    type: {
      "default": ""
    }
  },
  emits: ["click"],
  setup: function setup(__props, _ref) {
    var __emit = _ref.emit;
    var emits = __emit;
    var props = __props;
    var cardTypeClass = computed(function () {
      return props.type === "news" ? "news-card" : props.type;
    });
    var cardImgClass = computed(function () {
      return props.type ? "".concat(props.type, "-img") : "";
    });
    return function (_ctx, _cache) {
      return _openBlock(), _createElementBlock("div", {
        "class": _normalizeClass(["card", [cardTypeClass.value, _ctx.$attrs['class']]]),
        "data-cy": _ctx.$attrs['data-cy'],
        onClick: _cache[0] || (_cache[0] = function ($event) {
          return emits('click');
        })
      }, [_createElementVNode("div", {
        "class": _normalizeClass(["card-img", [cardImgClass.value, _ctx.$attrs['card-img-classes']]])
      }, [_renderSlot(_ctx.$slots, "card-image")], 2 /* CLASS */), _createElementVNode("div", {
        "class": _normalizeClass(["card-body", [_ctx.$attrs['card-body-classes']]])
      }, [_renderSlot(_ctx.$slots, "card-description")], 2 /* CLASS */)], 10 /* CLASS, PROPS */, _hoisted_1);
    };
  }
}));